import api from "../../../api";
import {typedQuery} from "../../typing";

export const accounts = typedQuery(["internal", "accounts"], async () => {
  return await api.internal.accounts.listAccounts();
});
